import React from "react";
import styled from "styled-components";

import CenteredWrapper from "components/designSystems/appsmith/CenteredWrapper";
import { Spinner } from "@appsmith/ads";

const LoadingContainer = styled(CenteredWrapper)`
  height: 50%;
`;

function Loader() {
  return (
    <LoadingContainer data-testid="t--loader-module">
      {/*@ts-expect-error Fix this the next time the file is edited*/}
      <Spinner size={30} />
    </LoadingContainer>
  );
}

export default Loader;
